/** 控制台「设备」下自建菜单（计量设备 + 设备公摊组及详情），中文为路由展示原文 */
export default {
  deviceMenu: {
    meteringDivider: '计量设备',
    sharingDivider: '设备公摊组',
    electricity: '电表',
    electricityDetail: '电表详情',
    water: '水表',
    waterDetail: '水表详情',
    hvac: '空调',
    hvacDetail: '空调详情',
    electricitySharing: '电表公摊组',
    electricitySharingDetail: '电表公摊详情',
    waterSharing: '水表公摊组',
    waterSharingDetail: '水表公摊详情',
    hvacSharing: '空调公摊组',
    hvacSharingDetail: '空调公摊详情'
  }
}
